//------------------------------------------------------------------------//
//  LOCAL FUNCTIONS
//------------------------------------------------------------------------//
// const functionName = () => {
//
// };
//------------------------------------------------------------------------//
//  EXPORT MODULE FUNCTIONS
//------------------------------------------------------------------------//
// export const functionName = () => {
//
// }
export const waitForRender = function (element) {
    return new Promise((resolve) => {
        const observer = new MutationObserver((mutations, observer) => {
            mutations.forEach(mutation => {
                if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
                    if(element.classList.contains('hydrated')) {
                        observer.disconnect();
                        resolve(element);
                    }
                }
            });
        })

        observer.observe(element, {childList: true, subtree: true, attributes: true });
    });
};

export const navTopPosition = (mediaQueries) => {
    const header = document.querySelector('.js-header');
    const headerHeight = header.offsetHeight;

    if(mediaQueries.xl.matches){
        const dropdowns = document.querySelectorAll('.dropdown-menu');

        dropdowns.forEach(dropdown => {
            dropdown.classList.add('mt-5');
        });
    } else {
        const offCanvas = document.querySelector('.js-offcanvas-primary');

        if (offCanvas) {
            offCanvas.style.setProperty('top', headerHeight + 'px');
        }
    }
};    

export const setLeftOffset = (mediaQueries) => {
    const offsetElement = document.querySelectorAll('.js-left-offset');

    if (offsetElement) {
        offsetElement.forEach(element => {
            if (mediaQueries.lg.matches) {
                const containerOffsetLeft = document.querySelector('.container').offsetLeft + 12 + "px";
                element.style.marginLeft = containerOffsetLeft;
            } else {
                element.style.marginLeft = "0px";
            }
        });
    }
}

//------------------------------------------------------------------------//
//  DYNAMIC EXPORT MODULE FUNCTIONS
//------------------------------------------------------------------------//
// export const import[Function Name] = (type) => {
// 	import([Package Name]).then(({ default: [Package Namespace] }) => {
//			
//     });
// }